import { View } from "@/components/ui/view";
import { Text } from "@/components/ui/text";
import React, { useEffect, useState } from 'react';
import useIsMounted from "../../hooks/mounted";
import { useSelector } from 'react-redux';

export default function TimerDisplay({ taskid }) {

    const [timer, setTimer] = useState('')
    const [intTimer, setIntTimer] = useState(null)
    const step = useSelector((state) => state.workflows[taskid].steps[state.workflows[taskid].step])

    const mounted = useIsMounted()

    useEffect(() => {
        console.log('STEP', step)
        calcTimer(step)
    }, [step])

    useEffect(() => {
        if (step.timerBeg && !step.timerPause) {
            if (!intTimer) {
                console.log('TD: start timer refresh')
                calcTimer(step)
                setIntTimer(setInterval(calcTimer, 1000, step))
            }
        } else {
            if (intTimer) {
                console.log('TD: stop timer refresh')
                calcTimer(step)
                clearInterval(intTimer)
                setIntTimer(null)
            }
        }
    }, [step.timerBeg, step.timerPause])

    useEffect(() => {
        return () => {
            if (!mounted()) {
                if (intTimer) {
                    console.log('TD: end timer refresh')
                    clearInterval(intTimer)
                    setIntTimer(null)
                }
            }
        };
    }, [mounted])

    const calcTimer = step => {
        if (step.timer) {
            let time = step.timer
            if (step.timerBeg) {
                if (step.timerPause) {
                    time = step.timer - Math.round((step.timerPause - step.timerBeg) / 1000)
                } else {
                    time = step.timer - Math.round((Date.now() - step.timerBeg) / 1000)
                }
            }
            time=Math.max(time, 0)
            setTimer(Math.floor(time / 3600) + (Math.floor((time % 3600) / 60) < 10 ? ':0' : ':') + Math.floor((time % 3600) / 60) + (Math.floor((time % 3600) % 60) < 10 ? ':0' : ':') + Math.floor((time % 3600) % 60))
        } else {
            setTimer('')
        }
    }

    return (
        <View className="m-3 border rounded-sm border-primary-900 items-center">
            <Text key={timer} bold className={` ${timer.startsWith('-') ? "text-ina_red" : "text-secondary-900"} text-5xl leading-5xl `}>{timer}</Text>
        </View>
    );
}